import React from 'react'
import { Link } from 'react-router-dom'

const SubTitle = ({ title, btntitle, pathlink, handleSeeMoreFunction }) => {
  return (
    <div className="d-flex justify-content-between  align-items-center">
      <div className="fw-bold fs-30 dark-color">{title}</div>
      {btntitle ? (
        <Link to={pathlink} onClick={handleSeeMoreFunction}>
          <div className="fw-bold fs-16 border px-3 py-2 dark-color rounded">{btntitle}</div>
        </Link>
      ) : null}
    </div>
  )
}

export default SubTitle
